import { createAsyncThunk } from '@reduxjs/toolkit';

import type { TrialStatusResponse } from '../../types';
import { contractsService } from '../services';

export const fetchTrialStatus = createAsyncThunk<
  TrialStatusResponse,
  void,
  { rejectValue: string }
>('contractsTrialStatus/fetch', async (_arg, { rejectWithValue }) => {
  try {
    return await contractsService.fetchTrialStatus();
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Falha ao obter o status do teste',
    );
  }
});
